<template>
    <div class="wf-landing-page-tab-container mb-3 mt-3">
        <div class="mobile-navigation mb-2">
            <div class="wf-mobile-title">
                {{title}}
            </div>
            <select class="custom-select" v-on:change="changeTab">
                <option v-for='(document, index) in documents' 
                    :key="document.id" :selected="index === 0"
                    :value="document.id">
                    {{document.title}}
                </option>
            </select>
        </div>

        <div class="wf-landing-page-tab-wrapper pr-2">    
            <div class="wf-landing-page-tab border-bottom">
                {{title}}
            </div>           
            <div v-for='(document, index) in documents' 
                :key="document.id"
                :id="document.id"
                :class="[index == 0 ? 'wf-landing-page-tab wf-landing-page-tab-active' : 'wf-landing-page-tab', index != documents.length - 1 ? '' : 'border-bottom']"
                v-on:click="changeTab">
                {{document.title}}
            </div>
        </div>
        <div class="wf-landing-page-tab-content">
            <section class="wf-landing-page-tab-content-section">
                <div v-if="documents && documents.length > 0" class="h4">{{ title }}</div>
                <div class="widget-content" v-html="this.pageContent"></div>
            </section>
        </div>
    </div>
</template>

<script>
import PatcraftApi from '../../scripts/patcraft-api';

export default {
    data() {
        return {
            pageContent: ` `
        }
  },
    props:{
        documents: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        }
    },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  methods: {
    fetchData (id = 0) {
        let docID = id;
        if(docID === 0) docID = this.documents.length > 0 ? this.documents[0].id : id;
      
        if(docID === 0) return;
        
        PatcraftApi.getLendingPagePartialView(docID)
            .then(response => {
                this.pageContent = response.data;
              });
    },
    changeTab(event) {
        const documentID = Number(event.target.tagName === 'SELECT' ? event.target.value : event.target.id);
        this.fetchData(documentID);

        let tabs = document.querySelectorAll('.wf-landing-page-tab');

        for (let i = 0; i < tabs.length; i++) {
            const element = tabs[i];
            if(Number(element.id) === documentID){
                element.classList.add('wf-landing-page-tab-active');
            }
            else{
                element.classList.remove('wf-landing-page-tab-active');
            }
        }
    }
  }
};
</script>